import { api } from '@/lib/api'
import { defaultPaginationMeta, parseMasterCatalogResponse } from '@/lib/api/masterCatalog'

/** @typedef {import('@/types/api').Stylist} Stylist */

export const COMMON_STYLIST_SKILLS = [
  'balayage',
  'blow_dry',
  'colour',
  'cut',
  'facial',
  'gel_manicure',
  'hair_treatment',
  'keratin',
  'massage',
  'nails',
  'pedicure',
  'waxing',
]

/**
 * @param {string} value
 */
export function normalizeSkill(value) {
  return value.trim().toLowerCase().replace(/\s+/g, '_')
}

/**
 * @param {string} value
 * @returns {string[]}
 */
export function parseSkillsInput(value) {
  return [...new Set(value.split(',').map(normalizeSkill).filter(Boolean))]
}

/**
 * @param {Record<string, unknown>} [params]
 * @returns {Promise<{ items: Stylist[], meta: import('@/types/api').PaginationMeta }>}
 */
export async function fetchStylistsPage(params = {}) {
  const { data } = await api.get('/masters/stylists', { params })
  const parsed = parseMasterCatalogResponse(data, 'stylists')
  return {
    items: parsed.items,
    meta: defaultPaginationMeta(parsed.meta ?? {}),
  }
}

/**
 * @param {Record<string, unknown>} [params]
 * @returns {Promise<Stylist[]>}
 */
export async function fetchStylistsList(params = {}) {
  const { data } = await api.get('/masters/stylists', { params })
  return data.data.stylists
}

/**
 * @returns {Promise<Stylist[]>}
 */
export async function fetchStylists() {
  return fetchStylistsList()
}

/**
 * @param {number} stylistId
 * @returns {Promise<Stylist>}
 */
export async function fetchStylist(stylistId) {
  const { data } = await api.get(`/masters/stylists/${stylistId}`)
  return data.data.stylist
}

/**
 * @param {Partial<Stylist>} payload
 * @returns {Promise<Stylist>}
 */
export async function createStylist(payload) {
  const { data } = await api.post('/masters/stylists', payload)
  return data.data.stylist
}

/**
 * @param {number} stylistId
 * @param {Partial<Stylist>} payload
 * @returns {Promise<Stylist>}
 */
export async function updateStylist(stylistId, payload) {
  const { data } = await api.put(`/masters/stylists/${stylistId}`, payload)
  return data.data.stylist
}
